import { updateValues } from "../../../config/firebase";

const getProjectData = async (project) => {
    // write the code here
    let response = await updateValues('GET', `liveBOQ/${String(project.ProjectId)}`, null);
    return response?.data?.Rooms || [];
}

export default getProjectData;